import { createFileRoute } from '@tanstack/react-router';
import LogTemplateView from '../../../features/baseData/logTemplates/logTemplate/view';
import {
  createPermissionGuard,
  getPermissionSet,
  LOG_TEMPLATES_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/verfuegungsvorlagen/$logTemplateId',
)({
  component: LogTemplateView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(LOG_TEMPLATES_PERMISSIONS, 'READ'),
  ),
});

export const ViewLogTemplateRoute = Route;
